import { useEffect, useState } from '../../vendor/react';
import {
  clearSyncedHistory,
  createOfflineValidationChange,
  createValidationConflict,
  exportLocalBackup,
  getOfflineState,
  importLocalBackup,
  initializeOfflineEngine,
  installPwa,
  resolveSyncConflict,
  retryFailedOperations,
  subscribeOfflineState,
  synchronizeNow,
  type ConflictResolution,
  type OfflineState,
} from './offline-engine';

const initialState: OfflineState = {
  ready: false,
  connection: navigator.onLine ? 'online' : 'offline',
  editionId: 'trial',
  editionName: 'Prueba gratuita',
  indexedDbAvailable: 'indexedDB' in window,
  serviceWorkerReady: false,
  installAvailable: false,
  persistentStorage: false,
  storageUsedBytes: 0,
  storageQuotaBytes: 0,
  trackedDatasets: 0,
  pendingOperations: 0,
  syncedOperations: 0,
  errorOperations: 0,
  openConflicts: 0,
  queue: [],
  conflicts: [],
};

export function useOffline() {
  const [state, setState] = useState<OfflineState>(initialState);
  const refresh = () => { void getOfflineState().then(setState); };
  useEffect(() => {
    void initializeOfflineEngine().then(refresh);
    const unsubscribe = subscribeOfflineState(refresh);
    return unsubscribe;
  }, []);
  return {
    ...state,
    actions: {
      refresh,
      syncNow: async () => { await synchronizeNow(); refresh(); },
      retry: async () => { await retryFailedOperations(); refresh(); },
      install: async () => { const result = await installPwa(); refresh(); return result; },
      exportBackup: exportLocalBackup,
      importBackup: importLocalBackup,
      createOfflineValidationChange,
      createValidationConflict: async () => { await createValidationConflict(); refresh(); },
      resolveConflict: async (id: string, resolution: ConflictResolution) => { await resolveSyncConflict(id, resolution); refresh(); },
      clearSynced: async () => { await clearSyncedHistory(); refresh(); },
    },
  };
}
